import React, { PropsWithChildren } from "react";
import Grid from '@mui/material/Grid2';
import { Box, styled } from "@mui/material";
import Typography from "@common/components/Typography";
import { useTranslation } from "react-i18next";

interface SectionProps {
  title: string;
  subSection?: boolean;
  direction?: "column" | "row";
}
const MainSectionContainer = styled(Box)(({ theme }) => ({
  "&:not(:last-child)": {
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.common.grey.dark}`,
  },
}));
const Section = (props: PropsWithChildren<SectionProps>) => {
  const { title, children, subSection = false, direction = "row" } = props;
  const { t } = useTranslation();

  const Container = subSection ? Box : MainSectionContainer;

  return (
    <Container paddingTop={2}>
      <Typography
        fontWeight={500}
        sx={(theme) => ({
          color: subSection
            ? theme.palette.text.primary
            : theme.palette.common.grey.light,
        })}
      >
        {t(title)}
      </Typography>
      <Grid
        container
        direction={direction}
        sx={{
          marginTop: 2,
          "& > .MuiButtonBase-root": {
            marginRight: 1,
            marginBottom: 1,
          },
        }}
      >
        {children}
      </Grid>
    </Container>
  );
};

export default Section;
